import CityPageTemplate from "../city-template/CityPageTemplate";
import { lafayetteInConfig } from "./data";

export default function LafayetteInPage() {
  return <CityPageTemplate config={lafayetteInConfig} />;
}